<template>
  <div class="ba-h-full ba-w-full ba-bg-white">
    <vis-file-storage @file-opened="onFileOpened" />

    <vis-gallery-viewer-modal
      v-if="isImageFile"
      :list="imageList"
      :start-item="file"
      @close="onFileClose"
    />
  </div>
</template>

<script>
const IMAGES_EXT_LIST = ["jpg", "jpeg", "png", "gif", "bmp"];

export default {
  name: "vis-file-storage-page",
  data() {
    return {
      file: null,
      dirItems: []
    };
  },
  computed: {
    isImageFile() {
      const ext = this.file?.extension?.toLowerCase();
      return IMAGES_EXT_LIST.indexOf(ext) >= 0;
    },
    imageList() {
      if (this.isImageFile) {
        return this.dirItems.filter(item => {
          const ext = item.extension?.toLowerCase();
          return IMAGES_EXT_LIST.indexOf(ext) >= 0;
        });
      }
      return [];
    }
  },
  methods: {
    onFileOpened({ file, dirItems }) {
      this.file = file;
      this.dirItems = dirItems;
    },
    onFileClose() {
      this.file = null;
      this.dirItems = [];
    }
  }
};
</script>
